import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { useIntl } from "react-intl";
import { Col } from "reactstrap";
import ProjectProfitabilityTable from "../Profitability/ProjectProfitabilityTable";
import { ProjectDTO } from "../../models/Project/ProjectDTO";
import AssistancesFromProject from "../Assistances/AssistanceFromProject";
import { useParams } from "react-router-dom";
import EquipmentsFromProject from "../Equipments/EquipmentsFromProject";
import ProjectProfitabilityBilledTable from "../Profitability/ProjectProfitabilityBilledTable";

type ProjectNavBarType = {
    project: ProjectDTO;
    reloadExecutions: boolean;
    childrenColumnSize?: number;
    loadingUpdate: boolean;
    profitabilityModule: boolean;
};

export function ProjectNavBar({ project, reloadExecutions, childrenColumnSize = 12, loadingUpdate, profitabilityModule }: ProjectNavBarType) {

    const intl = useIntl();
    const [activeTab, setActiveTab] = useState<number>(0);
    const { id } = useParams<{ id: string }>();

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                    value={activeTab}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label={intl.formatMessage({ id: "Screens.Project.Navbar.Assistances" })} {...a11yProps(0)} />
                    <Tab label={intl.formatMessage({ id: "Screens.Project.Navbar.Equipments" })} {...a11yProps(1)} />
                    {profitabilityModule &&
                        <Tab label={intl.formatMessage({ id: "Screens.Project.Navbar.Profitability" })} {...a11yProps(2)} />
                    }
                    {profitabilityModule &&
                        <Tab label={intl.formatMessage({ id: "Screens.Project.Navbar.ProfitabilityBilled" })} {...a11yProps(3)} />
                    }
                </Tabs>
            </Box>
            {profitabilityModule && (
                <TabPanel value={activeTab} index={2} childrenColumnSize={childrenColumnSize}>
                    <ProjectProfitabilityTable
                        projectId={id ?? ''}
                        reloadExecutions={reloadExecutions}
                        loadingUpdate={loadingUpdate}
                    />
                </TabPanel>
            )}
            {profitabilityModule && (
                <TabPanel value={activeTab} index={3} childrenColumnSize={childrenColumnSize}>
                    <ProjectProfitabilityBilledTable
                        projectId={id ?? ''}
                        reloadExecutions={reloadExecutions}
                        loadingUpdate={loadingUpdate}
                    />
                </TabPanel>
            )}
            <TabPanel value={activeTab} index={0} childrenColumnSize={childrenColumnSize}>
                <AssistancesFromProject ProjectErp={id ?? ""} />
            </TabPanel>
            <TabPanel value={activeTab} index={1} childrenColumnSize={childrenColumnSize}>
                <EquipmentsFromProject ProjectErp={id ?? ""} />
            </TabPanel>
        </>
    );
}

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    childrenColumnSize: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, childrenColumnSize, ...other } = props;

    return (
        <Col xl={childrenColumnSize}>
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <>{children}</>}
            </div>
        </Col>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
